import { useTranslation } from 'react-i18next';
import { canUseAi, normalizePlan } from '../data/subscriptions';

export const usePlanLabel = (plan?: string | null, includeUpgradeSuffix = false): string => {
  const { t } = useTranslation();
  const normalized = normalizePlan(plan);
  const name = t(`plans.${normalized}`);

  if (includeUpgradeSuffix && !canUseAi(plan)) {
    return `${name}${t('plans.upgradeSuffix')}`;
  }

  return name;
};
